export const ADD_FOCUSED_ELEMENT = 'ADD_FOCUSED_ELEMENT';
export const REMOVE_FOCUSED_ELEMENT = 'REMOVE_FOCUSED_ELEMENT';
export const ADD_ACTIVE_ELEMENT = 'ADD_ACTIVE_ELEMENT';
export const REMOVE_ACTIVE_ELEMENT = 'REMOVE_ACTIVE_ELEMENT';